import React from 'react'
import {Row,Col} from 'react-bootstrap'
import { useSelector} from "react-redux"

const Lista  = (props) => {
   const pytania = useSelector((magazyn) => magazyn.pytania)
   //const index_P  = props.index
   const tab    = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]
   const liczba_rek = 20 - pytania.length
   const index_P  = props.index + liczba_rek
   const klasa_A = 'list-group-item'
   const klasa_B = 'list-group-item list-group-item-dark' 
        return(
            <Row>
                <Row>
                    <Col xs={2}></Col>
                    <Col xs={10}>
                        <ol className='list-group list-group-horizontal'>
                            {tab.map((wart,index) => (
                                index < liczba_rek ? 
                                <li className="list-group-item list-group-item-dark" key={index}>{wart}</li>
                                :
                                index === index_P ? 
                                <li className="list-group-item active" key={index}>{wart}</li>
                                : <li className= {index < index_P ? klasa_B: klasa_A} key={index}>{wart}</li>
                              ))
                            }
                        </ol>
                    </Col>
                </Row>
            </Row>  
        )
}

export default Lista